import React, { useState, useEffect } from "react";

import Error from "./Error";
import Loader from "./Loader";
import MainProductArea from "./MainProductArea";

import { useProduct } from "../services/hooks/useProduct";
import { useGlobal } from "../services/hooks/useGlobal";
import BreadCrumbs from "./BreadCrumbs";
import Footer from "./Footer";

const Product = React.memo(() => {
  const { product, productStatus, productError } = useProduct();

  const [showErrorPage, setShowErrorPage] = useState(false);

  const { setPageTitle } = useGlobal();

  useEffect(() => {
    if (product) {
      setPageTitle({
        pageTitle: product.name,
      });

      return () => {
        setPageTitle({
          pageTitle: null,
        });

        setShowErrorPage(false);
      };
    }
  }, [product]);

  useEffect(() => {
    if (productError) {
      setShowErrorPage(true);

      return () => {
        setShowErrorPage(false);
      };
    }
  }, [productError]);

  if (showErrorPage) {
    return <Error statusCode={404} />;
  }

  if (productStatus !== "ready" || !product) {
    return <Loader absoluteCenter />;
  }

  return (
    <>
      <BreadCrumbs
        links={[
          { url: "/", name: "Home" },
          {
            url: `/products/${product?.id}`,
            name: `${product?.name}`,
          },
        ]}
      />
      <MainProductArea product={product} />
      <Footer />
    </>
  );
});

export default Product;
